import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  safetyOptionsSection: {
    marginTop: 16
  },
  safetyOptionPreviewItem: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  blockUnratedUrlsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 32
  },
  blockUnratedUrlsTitle: {
    marginBottom: 'unset'
  }
})

export default useStyles
